import { render, staticRenderFns } from "./bin-comments.vue?vue&type=template&id=2e1ab0fd"
import script from "./bin-comments.vue?vue&type=script&lang=js"
export * from "./bin-comments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports